import React, { useEffect, useState } from "react";
import { Form, NavLink, useNavigate } from "react-router-dom";
import { SignInImages, people } from "../config/imagesLink";
import AuthSplitLayout from "./Auth/AuthSplitLayout";
import AuthField from "./Auth/AuthField";
import MailOutlineOutlinedIcon from "@mui/icons-material/MailOutlineOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import PersonAddAlt1OutlinedIcon from "@mui/icons-material/PersonAddAlt1Outlined";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
// import { Register, TestApi } from '../Services/Service'
import { useFormik } from "formik";
import { registerValidations } from "./Validations";
import axios, { PublicKey } from "../API/axios";
import { completeLoginNotificationFetch } from "../Services/apiService";
import { GA_MEASUREMENT_ID } from "../config/appConfig";
import fetch_axios from "axios";
import { useGoogleLogin } from "@react-oauth/google";
import { useToaster } from "react-hot-toast";
import SuccessToast from "./SuccessToast";
import WarningToast from "./WarningToast";
import ErrorToast from "./ErrorToast";
import { getAuth, signInWithPopup, OAuthProvider } from "firebase/auth";
import { initializeApp } from "firebase/app";
import OtpInput from "react-otp-input";
import { useTranslation } from "react-i18next";
import i18n from "../i18n";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { setStoredLangCode } from "../utils/language";


const shouldEnableFirebaseAnalytics = (() => {
  if (process.env.NODE_ENV !== "production") return false;
  if (typeof window === "undefined") return false;
  const host = String(window.location.hostname || "").toLowerCase();
  const isProdHost =
    host === "welinkjobs.com" ||
    (host.endsWith(".welinkjobs.com") && !host.startsWith("preprod."));
  return isProdHost;
})();


const firebaseConfig = {
  apiKey: "AIzaSyD8GJvS-To2H4dOM8lbn5JRUQVhCL8uxJM",
  authDomain: "welinkjobs-23583.firebaseapp.com",
  projectId: "welinkjobs-23583",
  storageBucket: "welinkjobs-23583.appspot.com",
  messagingSenderId: "375220227786",
  appId: "1:375220227786:web:bb1fd63622ce66d4936e33",
  ...(shouldEnableFirebaseAnalytics
    ? { measurementId: GA_MEASUREMENT_ID }
    : {}),
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const SignUp = () => {
  const { success } = useToaster();
const { t } = useTranslation();
  const navigate = useNavigate();
  const [User_Name, setuserName] = useState("");
  const [Response_Message, setmessage] = useState("");
 const language = localStorage.getItem("Lang");
  const [currentLang, setCurrentLang] = useState(i18n?.language || language || "en");
  //************************ Country Flag code start  ************************//

  // const [items, setItems] = useState([]);

  // useEffect(() => {
  //     fetch(
  //         "https://raw.githubusercontent.com/iamspruce/search-filter-painate-reactjs/main/data/countries.json"
  //     )
  //         .then((res) => res.json())
  //         .then(
  //             (result) => {
  //                 // setLoaded(true);
  //                 setItems(result);
  //                 // console.log(result);
  //             },
  //             (error) => {
  //                 // setLoaded(true);
  //                 // setError(error);
  //             }
  //         );
  // }, []);
  // const data = Object.values(items);

  // const [isOpen, setIsOpen] = useState(false);
  // const [selectedItem, setSelectedItem] = useState(null);
  // const [searchTerm, setSearchTerm] = useState('');
  // // console.log('selectedItem', selectedItem.callingCode);
  // const filteredData = data.filter(item =>
  //     item.name.toLowerCase().includes(searchTerm.toLowerCase())
  // );

  // const handleItemClick = (item) => {
  //     setSelectedItem(item);
  //     setIsOpen(false);
  // };
  //************************ Country Flag code End  ************************//

  //************************ Register With Email Start  ************************//

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [sessionId, setSessionId] = useState("");
  const [userID, setuserID] = useState("");
  const [loading, setLoading] = useState(false);
  const [flag, setFlag] = useState(false);
  const [otp, setOtp] = useState("");
  const handleChangeOtp = (otp) => setOtp(otp);
  const getResponseMessage = (response, fallback = "Success") =>
    response?.data?.message || response?.message || fallback;
  const getErrorMessage = (error, fallback = "Something went wrong") =>
    error?.response?.data?.message || error?.message || fallback;
  const resetToasts = () => {
    setShowToast(false);
    setToastMessage("");
    setShowWarningToast(false);
    setWarningToastMessage("");
    setShowErrorToast(false);
    setErrorToastMessage("");
  };

  const initialValues = {
    email: "",
    firstname: "",
    lastname: "",
    password: "",
    confirmPassword: "",
    register_checkbox: false,
  };
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const [showConfirmPassword, setshowConfirmPassword] = useState(false);

  const toggleConfirmPasswordVisibility = () => {
    setshowConfirmPassword(!showConfirmPassword);
  };
  // console.log("res", sessionId, userID);

  const { values, errors, handleBlur, touched, handleChange, handleSubmit } =
    useFormik({
      initialValues,
      validationSchema: registerValidations,
      onSubmit: async () => {
        setLoading(true);
        resetToasts();
        const RegisterData = {
          deviceType: "Web",
          email: values.email,
          password: values.password,
          confirmPassword: values.confirmPassword,
          firstName: values.firstname,
          lastName: values.lastname,
          langKey: language === "en" ? "" : language,

        };

        try {
          await axios
            .post("OAuth/RegisterWithEmail", RegisterData, {
              headers: {
                PublicKey,
              },
            })
            .then(async (response) => {
              // debugger;
              setStoredLangCode(language === null ? "en" : language);
              const responseMessage = getResponseMessage(response);

              if (response.status === "Success") {
                const responseNew = response.responseData.profile;
                const userRole = response.responseData.userRoles;
                setToastMessage(responseMessage);
                setShowToast(!!String(responseMessage).trim());
                setuserID(response.data.responseData.userId);
                console.log("Response New", response.responseData);
                localStorage.setItem("user-Id", responseNew.id);
                localStorage.setItem("userUid", responseNew.userUid);
                localStorage.setItem("user-email", responseNew.email);
                localStorage.setItem("user-nameTag", responseNew.nameTag);
                localStorage.setItem("user-profilPic", responseNew.profilPic);
                localStorage.setItem("user-referCode", responseNew.referCode);
                localStorage.setItem("sessionId", responseNew.sessionId);
                localStorage.setItem("token", responseNew.token);
                if (responseNew.refreshToken) {
                  localStorage.setItem("refreshToken", responseNew.refreshToken);
                }
                localStorage.setItem("loginType", responseNew.loginType);
                localStorage.setItem("profilPic", responseNew.profilPic);
                localStorage.setItem("firstName", responseNew.firstName);
                localStorage.setItem("lastName", responseNew.lastName);
                localStorage.setItem("userRole", userRole);
                setSessionId(response.data.responseData.sessionID);


                localStorage.removeItem("guestMode");
                await completeLoginNotificationFetch();
                setTimeout(() => {
                  navigate("/Newsfeed");
                }, 2000);
              } else {
                setToastMessage(responseMessage);
                setShowToast(!!String(responseMessage).trim());
                setFlag(true);
                setuserName(response.data.responseData.userName);
                setmessage(responseMessage);
                setSessionId(response.data.responseData.sessionID);
                setuserID(response.data.responseData.userId);
              }
            });
        } catch (error) {
          // debugger;
        setStoredLangCode(language === null ? "en" : language);
          const errorMessage = getErrorMessage(error);

          if (error.response && error.response.status === 403) {
            setToastMessage(errorMessage);
            setShowToast(!!String(errorMessage).trim());
            setFlag(true);
            setuserName(error.response.data.responseData.userName);
            setmessage(errorMessage);
            setSessionId(error.response.data.responseData.sessionID);
            setuserID(error.response.data.responseData.userId);
          } else if (error.response && error.response.status === 404) {
            setWarningToastMessage(errorMessage);
            setShowWarningToast(true);
          } else {
            setErrorToastMessage(errorMessage);
            setShowErrorToast(true);
          }
        } finally {
          setLoading(false);
        }
      },
    });
  const otpCheck = async (e) => {
    e.preventDefault();
    resetToasts();
    try {
      // console.log("OTP:", otp);
      // console.log("SessioID:", sessionId);
      // console.log("UserID:", userID);

      await axios
        .post(
          `OAuth/ConfirmAccountByOTP?OTP=${otp}&SessionID=${sessionId}&UserID=${userID}&DeviceType=Web`,
          {},
          { headers: { PublicKey } }
        )

        .then(async (res) => {
          console.log("res", res);
          const responseMessage = getResponseMessage(res);
          setToastMessage(responseMessage);
          setShowToast(!!String(responseMessage).trim());
          setFlag(false);

          const data = res.data.responseData;
          const response = res.data.responseData.profile;
          const userRole = res.data.responseData.userRoles;
          setStoredLangCode(language === null ? "en" : language);

          localStorage.setItem("user-Id", response.id);
          localStorage.setItem("userUid", response.userUid);
          localStorage.setItem("user-email", response.email);
          localStorage.setItem("user-nameTag", response.nameTag);
          localStorage.setItem("user-profilPic", response.profilPic);
          localStorage.setItem("user-referCode", response.referCode);
          localStorage.setItem("sessionId", response.sessionId);
          localStorage.setItem("token", response.token);
          if (response.refreshToken) {
            localStorage.setItem("refreshToken", response.refreshToken);
          }
          localStorage.setItem("loginType", response.loginType);
          localStorage.setItem("profilPic", response.profilPic);
          localStorage.setItem("firstName", response.firstName);
          localStorage.setItem("lastName", response.lastName);
          localStorage.setItem("userRole", userRole);
          
          localStorage.setItem("engagedUsersMostEngagedPostIds", data.algoData.engagedUsersMostEngagedPostIds || "");
          localStorage.setItem("loggedInUser_EngagedUsersIDs", data.algoData.loggedInUser_EngagedUsersIDs || "");
          localStorage.setItem("peopleRecommendationsIds", data.algoData.peopleRecommendationsIds || "");
          localStorage.setItem("jobRecommendationsIds", data.algoData.jobRecommendationsIds || "");

          localStorage.setItem("companyRecommendationsIds", data.algoData.companyRecommendationsIds || "");
          localStorage.setItem("allPostsIds", data.algoData.allPostsIds || "");
          localStorage.setItem("restrictedViewerToken", data.algoData.restrictedViewerToken)
          localStorage.setItem("connectedUsersIDs", data.algoData.connectedUsersIDs || "");

          localStorage.setItem("followedCompaniesIDs", data.algoData.followedCompaniesIDs);
          localStorage.setItem("followedCompaniesPostsIds", data.algoData.followedCompaniesPostsIds);
          localStorage.setItem("followedUsersIDs", data.algoData.followedUsersIDs);
          localStorage.setItem("ownedMostEngagedPostIds", data.algoData.ownedMostEngagedPostIds)
          localStorage.setItem("ownedAllPostIds", data.algoData.ownedAllPostIds)

          localStorage.removeItem("guestMode");
          await completeLoginNotificationFetch();
          setTimeout(() => {
            navigate("/Newsfeed");
          }, 2000);
          // if (res.data.length === 0) {

          // } else {
          //   toast.error("Wrong OTP");
          // }
        });
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(errorMessage);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(errorMessage);
        setShowErrorToast(true);
      }
    }
  };
  //************************ Register With Email End  ************************//

  //************************ Register With Google Start  ************************//
  const [googleloading, setGoogleloading] = useState(false);

  const externalLogin = async (responseData) => {
    setGoogleloading(true);
    resetToasts();
    try {
      const response = await (
        await axios.post("OAuth/RegisterWithGoogle", responseData, {
          headers: {
            PublicKey,
          },
        })
      ).data;
      console.log("google response", response);
      setStoredLangCode(language === null ? "en" : language);

      if (response.status === "Success") {
        const responseNew = response.responseData.profile;
        const userRole = response.responseData.userRoles;
        setToastMessage(response.message || "Success");
        setShowToast(!!String(response.message || "Success").trim());
        setStoredLangCode(language === null ? "en" : language);
        localStorage.setItem("user-Id", responseNew.id);
        localStorage.setItem("userUid", responseNew.userUid);
        localStorage.setItem("user-email", responseNew.email);
        localStorage.setItem("user-nameTag", responseNew.nameTag);
        localStorage.setItem("user-profilPic", responseNew.profilPic);
        localStorage.setItem("user-referCode", responseNew.referCode);
        localStorage.setItem("sessionId", responseNew.sessionId);
        localStorage.setItem("token", responseNew.token);
        localStorage.setItem("loginType", responseNew.loginType);
        localStorage.setItem("profilPic", responseNew.profilPic);
        localStorage.setItem("firstName", responseNew.firstName);
        localStorage.setItem("lastName", responseNew.lastName);
        localStorage.setItem("userRole", userRole);

        localStorage.removeItem("guestMode");
        await completeLoginNotificationFetch();
        setTimeout(() => {
          navigate("/Newsfeed");
        }, 2000);
      } else {
        setStoredLangCode(language === null ? "en" : language);
        console.log("Lang", language === null ? "en" : language);
        
        setToastMessage(response.message || "Success");
        setShowToast(!!String(response.message || "Success").trim());
        setFlag(true);
        setuserName(response.data.responseData.userName);
        setmessage(response.data.message);
        setSessionId(response.responseData.sessionID);
        setuserID(response.responseData.userID);
      }
      // toast.success(response.message);
      // navigate("/SignIn");
    } catch (error) {
        setStoredLangCode(language === null ? "en" : language);
      const errorMessage = getErrorMessage(error);

      if (error.response && error.response.status === 403) {
        setToastMessage(errorMessage);
        setShowToast(!!String(errorMessage).trim());
        setFlag(true);
        setuserName(error.response.data.responseData.userName);
        setmessage(errorMessage);
        setSessionId(error.response.data.responseData.sessionID);
        setuserID(error.response.data.responseData.userID);
      } else if (error.response && error.response.status === 404) {
        setWarningToastMessage(errorMessage);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(errorMessage);
        setShowErrorToast(true);
      }
    } finally {
      setGoogleloading(false);
    }
  };
  const googleSignin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      // setIsLoading(false);
      try {
        const resp = await fetch_axios.get(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
            },
          }
        );
        const responseData = {
          deviceType: "Web",
          email: resp.data.email,
          externalLoginId: resp.data.sub,
          loginType: "Google",
          firstName: resp.data.given_name,
          lastName: resp.data.family_name,
          // profilPic: resp.data.picture,
        };
        externalLogin(responseData);
        // setIsLoading(true);
        // navigate("/NewsFeeds");
      } catch (error) {
        console.log(error);
        // setIsLoading(true);
      }
    },
  });
  //************************ Register With Google End  ************************//

  // Load Apple Sign-In script
  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const handleAppleSignIn = () => {
    try {
      if (window.AppleID) {
        window.AppleID.auth.init({
          clientId: "com.welinkjob.welink",
          scope: "email",
          redirectURI: "https://v2-web-app-pd29.vercel.app/signIn",
          state: "4ee08dcf-73ac-4569-7336-4e5d867b0599",
          usePopup: true,
        });

        window.AppleID.auth
          .signIn()
          .then((response) => {
            console.log("response", response); // Handle the response from Apple
          })
          .catch((error) => {
            console.error("Sign-In Error:", error); // Handle sign-in errors
          });
      } else {
        console.error(
          "AppleID is not defined. Ensure the script is loaded correctly."
        );
      }
    } catch (error) {
      console.error("Unexpected Error:", error);
    }
  };

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [originalemail, setOriginalEmail] = useState("");
  const [accessToken, setAccessToken] = useState("");
  const [photoUrl, setPhotoUrl] = useState("");
  const [externalEmail, setExernalEmail] = useState("");

  const [showModal, setShowModal] = useState(false);
  const handleModalOpen = () => setShowModal(true);
  const handleModalClose = () => setShowModal(false);
  const handleOtpModalClose = () => {
    setFlag(false);
    setOtp("");
  };

  const RegisterWithApple = async () => {
    const provider = new OAuthProvider("apple.com");
    provider.addScope("email");
    provider.addScope("name");

    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      // const credential = OAuthProvider.credentialFromResult(result);
      // const accessToken = credential.accessToken;
      console.log("accessToken", user);
      setFirstName(user.displayName?.split(" ")[0]);
      setLastName(user.displayName?.split(" ")[1]);
      setExernalEmail(user.email);
      setAccessToken(user.accessToken);
      setPhotoUrl(user.photoURL);
      handleModalOpen();
    } catch (error) {
      console.error("Error signing in with Apple:", error);
    }
  };

  const _registerWithAppleApi = async () => {
    try {
      const responseData = {
        deviceType: "Web",
        appleAccessToken: accessToken,
        loginType: "Apple",
        email: originalemail,
        langKey: language === "en" ? "" : language,

      };
      if (originalemail !== "" && firstName !== "" && lastName !== "") {
        const response = await axios.post(
          "OAuth/RegisterWithApple",
          responseData,
          {
            headers: {
              PublicKey,
            },
          }
        );
        setStoredLangCode(language === null ? "en" : language);

        if (response.status === "Success") {
          const responseNew = response.responseData.profile;
          const userRole = response.responseData.userRoles;
          setToastMessage(response.data.message);
          setShowToast(true);
          localStorage.setItem("user-Id", responseNew.id);
          localStorage.setItem("userUid", responseNew.userUid);
          localStorage.setItem("user-email", responseNew.email);
          localStorage.setItem("user-nameTag", responseNew.nameTag);
          localStorage.setItem("user-profilPic", responseNew.profilPic);
          localStorage.setItem("user-referCode", responseNew.referCode);
          localStorage.setItem("sessionId", responseNew.sessionId);
          localStorage.setItem("token", responseNew.token);
          localStorage.setItem("loginType", responseNew.loginType);
          localStorage.setItem("profilPic", responseNew.profilPic);
          localStorage.setItem("firstName", responseNew.firstName);
          localStorage.setItem("lastName", responseNew.lastName);
          localStorage.setItem("userRole", userRole);

          localStorage.removeItem("guestMode");
          await completeLoginNotificationFetch();
          setTimeout(() => {
            navigate("/Newsfeed");
          }, 2000);
        } else {
          setToastMessage(response.data.message);
          setShowToast(true);
          setFlag(true);
          setuserName(response.data.responseData.userName);
          setmessage(response.data.message);
          setSessionId(response.data.responseData.sessionID);
          setuserID(response.data.responseData.userId);
        }
      } else {
        setErrorToastMessage(t("modals.Please fill all the required fields"));
        setShowErrorToast(true);
      }
    } catch (error) {
      console.error("Error during registration:", error);
      setErrorToastMessage(error.response.data.message);
      setShowErrorToast(true);
    }
  };
  const [ConnectionListForGuest, setConnectionListForGuest] = useState("");
  const ConnectionListAllForGuest = async (id) => {
    try {
      await axios
        .get("UserFollow/GetMostFollowingUser?DeviceType=Web")
        .then((resData) => {
          // console.log("ConnectionListAllForGuest", resData.data.responseData);
          setConnectionListForGuest(resData.data.responseData);
        });
    } catch (error) {
      console.log(error);
    }
  }; 
  useEffect(() => {
    ConnectionListAllForGuest();
  }, []);
  const [guestMode, setGuestMode] = useState(false);
  const LinktoGuest = () => {
    setGuestMode(true);
    localStorage.setItem("guestMode", "true");
  };

  const [minutes, setMinutes] = useState(1);
  const [seconds, setSeconds] = useState(30);
  const resendOTP = async (e) => {
      if (seconds > 0 || minutes > 0) return;
      setMinutes(1);
      setSeconds(30);
      e.preventDefault();
    try {
      await axios.post(`OAuth/ResendOTP?UserID=${userID}`).then((res) => {
        console.log("res", res);
        setSessionId(res.data.responseData.sessionID);
        setToastMessage(res.data.message);
        setShowToast(true);
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  useEffect(() => {
    if (showModal || flag) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      document.body.classList.add("modal-open"); // When a modal opens
    } else {
      document.body.style.overflow = "unset";
      document.documentElement.style.overflow = "";
      document.body.classList.remove("modal-open"); // When a modal closes
    }
  }, [showModal, flag]);

  const handleProfileImageError = (e) => {
    if (!e || !e.target) return;
    e.target.onerror = null;
    e.target.src = people.DefaultProfile;
  };

    const changeLanguage = (lang) => {
        const code = setStoredLangCode(lang);
        i18n.changeLanguage(code);
        document.documentElement.lang = code;
        document.documentElement.dir = code === "ar" ? "rtl" : "ltr";
        setCurrentLang(lang);

        // document.body.dir = lang === "ar" ? "rtl" : "ltr"; // RTL for Arabic
      };

  const passwordValue = values.password || "";
  const passwordChecks = [
    {
      label: t("SignIn.At least 8 characters", { defaultValue: "At least 8 characters" }),
      met: passwordValue.length >= 8,
    },
    {
      label: t("SignIn.One uppercase letter", { defaultValue: "One uppercase letter" }),
      met: /[A-Z]/.test(passwordValue),
    },
    {
      label: t("SignIn.One number or symbol", { defaultValue: "One number or symbol" }),
      met: /[0-9]|[^A-Za-z0-9]/.test(passwordValue),
    },
  ];

  return (
    <>
      <AuthSplitLayout
        switchPrompt={t("SignIn.Already have an account")}
        switchTo="/SignIn"
        switchLabel={t("SignIn.Sign in")}
        connectionList={ConnectionListForGuest}
        onGuestNavigate={LinktoGuest}
        currentLang={currentLang}
        onChangeLanguage={changeLanguage}
        onProfileImageError={handleProfileImageError}
      >
        <div className="auth-form-heading">
          <h2>{t("SignIn.Create Your Account", { defaultValue: "Create Your Account" })}</h2>
          <p>
            {t("SignIn.Fill in the details below", {
              defaultValue: "Fill in the details below to get started.",
            })}
          </p>
        </div>

        <Form onSubmit={handleSubmit}>
          <AuthField
            id="email"
            name="email"
            type="text"
            placeholder={t("Manage Companies.Email Id")}
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.email}
            touched={touched.email}
            autoComplete="email"
            icon={<MailOutlineOutlinedIcon />}
          />

          <div className="auth-name-row">
            <AuthField
              id="firstname"
              name="firstname"
              type="text"
              placeholder={t("Newsfeed.First Name")}
              value={values.firstname}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.firstname}
              touched={touched.firstname}
              autoComplete="given-name"
              icon={<PersonOutlineOutlinedIcon />}
            />
            <AuthField
              id="lastname"
              name="lastname"
              type="text"
              placeholder={t("Newsfeed.Last Name")}
              value={values.lastname}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.lastname}
              touched={touched.lastname}
              autoComplete="family-name"
              icon={<PersonOutlineOutlinedIcon />}
            />
          </div>

          <AuthField
            id="password"
            name="password"
            type={showPassword ? "text" : "password"}
            placeholder={t("SignIn.Password")}
            value={values.password}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.password}
            touched={touched.password}
            autoComplete="new-password"
            icon={<LockOutlinedIcon />}
            rightSlot={
              <button
                type="button"
                className="auth-field-toggle"
                onClick={togglePasswordVisibility}
                aria-label="Toggle password visibility"
              >
                {showPassword ? <VisibilityOffOutlinedIcon /> : <VisibilityOutlinedIcon />}
              </button>
            }
          />

          <div className="auth-password-checks">
            {passwordChecks.map((check) => (
              <div className={`auth-check ${check.met ? "is-met" : ""}`} key={check.label}>
                {check.met ? <CheckCircleIcon /> : <RadioButtonUncheckedIcon />}
                <span>{check.label}</span>
              </div>
            ))}
          </div>

          <AuthField
            id="confirmPassword"
            name="confirmPassword"
            type={showConfirmPassword ? "text" : "password"}
            placeholder={t("SignIn.Confirm Password")}
            value={values.confirmPassword}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.confirmPassword}
            touched={touched.confirmPassword}
            autoComplete="new-password"
            icon={<LockOutlinedIcon />}
            rightSlot={
              <button
                type="button"
                className="auth-field-toggle"
                onClick={toggleConfirmPasswordVisibility}
                aria-label="Toggle confirm password visibility"
              >
                {showConfirmPassword ? <VisibilityOffOutlinedIcon /> : <VisibilityOutlinedIcon />}
              </button>
            }
          />

          <label className="auth-terms">
            <input
              type="checkbox"
              id="terms"
              name="register_checkbox"
              checked={!!values.register_checkbox}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            <span>
              {t("SignIn.By creating an account", {
                defaultValue: "By creating an account, you agree to our",
              })}{" "}
              <NavLink to="/terms-and-conditions.html" target="blank">
                {t("Sidemenubar.Terms & Conditions")}
              </NavLink>{" "}
              {t("SignIn.and")}{" "}
              <NavLink to="/privacy-policy.html" target="blank">
                {t("Sidemenubar.Privacy Policy")}
              </NavLink>
              .
            </span>
          </label>
          {errors.register_checkbox && touched.register_checkbox ? (
            <p className="auth-field-error">{errors.register_checkbox}</p>
          ) : null}

          <button
            type="submit"
            className="auth-submit"
            disabled={
              !values.email ||
              !values.firstname ||
              !values.lastname ||
              !values.password ||
              !values.confirmPassword ||
              !values.register_checkbox ||
              loading
            }
          >
            <PersonAddAlt1OutlinedIcon />
            {loading ? t("SignIn.Loading") : t("SignIn.Sign Up")}
          </button>
        </Form>

        <div className="auth-or">{t("SignIn.or continue with", { defaultValue: "or continue with" })}</div>
        <div className="auth-social-row">
          <button
            type="button"
            className="auth-social-btn"
            onClick={googleSignin}
            disabled={googleloading}
          >
            <img src={SignInImages.google} alt="" />
            {googleloading
              ? t("SignIn.Loading")
              : t("SignIn.Continue with Google", { defaultValue: "Continue with Google" })}
          </button>
          <button type="button" className="auth-social-btn" onClick={RegisterWithApple}>
            <img src={SignInImages.apple} alt="" />
            {t("SignIn.Continue with Apple", { defaultValue: "Continue with Apple" })}
          </button>
        </div>

        <div className="auth-safe-note">
          <ShieldOutlinedIcon />
          <span>
            {t("SignIn.Your information is safe", {
              defaultValue: "Your information is safe with us. We never share your data.",
            })}
          </span>
        </div>
      </AuthSplitLayout>

      <SuccessToast
        show={showToast && !!String(toastMessage || "").trim()}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />

      {showModal && (
        <div
          className="modal fade show modal-md"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="p-2 pt-4 text-center">
                <h6>Hi </h6>
                <p>
                  Please provide an email address to complete your WLJ profile
                  with associated apple account
                </p>
              </div>
              <Form>
                <div className="row modal-p settings CreateCompany">
                  <div className="col-md-12 mt-2">
                    <label htmlFor="about">
                      Email
                      <span className="text-danger ms-2">*</span>
                    </label>
                    <input
                      type="text"
                      value={originalemail}
                      onChange={(e) => setOriginalEmail(e.target.value)}
                    />
                  </div>

                  <div className="text-end mt-4">
                    <button
                      type="button"
                      className="closebtn me-2"
                      onClick={handleModalClose}
                      style={{ width: "60px" }}
                    >
                      {t("User Profile.Close")}
                    </button>
                    <button
                      type="button"
                      className="mainBtn1"
                      onClick={_registerWithAppleApi}
                      // style={{ width: "70px" }}
                    >
                      {t("User Profile.Submit")}
                    </button>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      )}
      {flag && (
        <div
          className="modal fade show modal-md"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="d-flex justify-content-end p-2 pb-0">
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 mt-2 pointer"
                  onClick={handleOtpModalClose}
                />
              </div>
              <div className="p-2 pt-2 text-center">
                <h4>Hi {User_Name},</h4>
                <h6>
                  <span className="fw-bold signUpModal">
                    Verify account by OTP
                  </span>{" "}
                </h6>
                <p>{Response_Message}</p>
              </div>
              <Form
                className="auth-register-form mt-1 phoneSignUp pt-2 pb-3"
                onSubmit={otpCheck}
                style={{ display: flag ? "block" : "none" }}
              >
                <div className="mb-1 d-flex justify-content-center otp-input">
                  <OtpInput
                    value={otp}
                    onChange={handleChangeOtp}
                    numInputs={4}
                    renderInput={(props) => <input {...props} />}
                  />
                </div>

                <div className="text-center mt-3">
                  <div className="countdown-text d-flex justify-content-center">
                    {seconds > 0 || minutes > 0 ? (
                      <p className="me-3">
                        Time Remaining: {minutes < 10 ? `0${minutes}` : minutes}
                        :{seconds < 10 ? `0${seconds}` : seconds}
                      </p>
                    ) : (
                      <p className="me-3">Didn't recieve code?</p>
                    )}

                    <span
                      style={{
                        color:
                          seconds > 0 || minutes > 0 ? "#DFE3E8" : "#FF5630",
                        pointerEvents: seconds > 0 || minutes > 0 ? "none" : "auto",
                        cursor: seconds > 0 || minutes > 0 ? "not-allowed" : "pointer",
                      }}
                      onClick={resendOTP}
                      className={seconds > 0 || minutes > 0 ? "" : "pointer"}
                    >
                      Resend OTP
                    </span>
                  </div>
                  <button type="submit" className="mainBtn mt-3">
                    {loading ? "loading..." : "Verify OTP"}
                  </button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SignUp;
